import { useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";

import { useCondition, useJourney } from "modules";
import { RootState } from "store";
import { getIsIdentified } from "store/selectors";

import { isEqual, some } from "lodash-es";

export const useImmersiveMode = () => {
  const { pathname: currentRoute } = useLocation();
  const accountStatus = useSelector((state: RootState) => state.account);
  const { hasActiveJourney } = useCondition({ hasActiveJourney: "journey.hasActiveJourney" });
  const sessionVerified = useSelector((state: RootState) => state.authentication.sessionVerified);
  const isIdentified = useSelector(getIsIdentified);

  const { currentStep } = useJourney();

  const routesToHide = [
    "/create-new-password",
    "/link-expired",
    "/login",
    "/new-device",
    "/wysh-builder/list",
    "/wysh-builder/:category?",
    "/wysh-builder/:wyshId?/info",
    "/wysh-builder/:wyshId?/add/:field?/:allocationId?",
    "/wyshes/:allocationId/edit/:field?",
    "/beneficiary/select-type/:lineOfBusiness/:responsibility",
    "/forgot-password",
    "/disclosure/:slug",
    "/packages-preview",
    "/coverage-preview",
    "/edit-coverage/:type",
    "/flow/:slug",
    "/beneficiary/:lineOfBusiness",
    "/ineligible/:slug",
    "/getting-coverage",
    "/products/insurance/billing/:edit?",
    "/products/insurance/get-wysh-estimate",
    "/products/insurance/welcome",
    "/products/insurance/wysh-builder/list",
    "/products/insurance/confirm-update",
  ];

  const isOnFlow = isEqual(currentStep?.type, "flow");
  const isOnRouteToHide = some(routesToHide, (path: string) =>
    matchPath({ path, end: true }, currentRoute)
  );

  const isSessionVerifyMode = !sessionVerified && !isIdentified;

  const immersiveConditions = [
    isOnRouteToHide,
    accountStatus.locked,
    accountStatus.fraudulentDevice,
    isOnFlow,
    hasActiveJourney,
    isSessionVerifyMode,
  ];
  const conditionsMet = some(immersiveConditions);

  return conditionsMet;
};
